import React, { useContext } from 'react';
import API from 'helpers/API';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import styles from './custom-event-types-list.scss';
import { headerStyle, style } from './styles';
import Svg from '../../../components/Svg';
import BackButton from '../../../components/BackButton';
import AddBtnRedesigned from '../../../components/AddFiltersBtnRedesigned/AddBtnRedesigned';
import { closePopup, showPopup } from '../../../actions';
import CustomEventTypesContext from './CustomEventTypesContext';
import { hasPermission } from '../../../helpers/auth';
import resources from '../../../constants/resources';
import TablePaginator from '../../../components/TablePaginator';

const CustomEventTypesList = ({ history }) => {
  const dispatch = useDispatch();
  const { customEventTypes, loadCustomEventTypes, shipmentFilters } = useContext(CustomEventTypesContext);

  const handleClickAddCustomEventType = () => {
    history.push('/settings/custom-event-types/add');
  };

  const handleDeleteUser = (props) => {
    dispatch(showPopup({
      title: 'Are you sure?',
      description: 'Removing a custom event type cannot be undone.',
      onAccept: async () => {
        await API.deleteCustomEventType(props.original.id);
        dispatch(closePopup());
        loadCustomEventTypes();
      },
    }));
  };

  const handleCantBeDeleted = () => {
    dispatch(showPopup({
      title: 'Custom event type in use',
      description: 'This custom event type cannot be deleted because it is in use by one or more shipment filters.',
    }));
  };

  const renderColumn = (value) => (
    <div className={cx(styles.renderColumnWrapper, styles.renderColumnStyles)}>
      <div className={styles.renderColumnStyles}>
        <span
          title={`${value}`}
        >{value}
        </span>
      </div>
    </div>
  );

  const showActions = () => hasPermission(resources.customEventTypes.edit);

  const unusedInShipmentFilters = (id) => shipmentFilters.filter(sf => sf.custom_event_types.includes(id)).length === 0;

  const renderActions = (props) => (
    <div className={styles.tableButtonsBlock}>
      <span className={styles.actionsBtnBlock}>
        <Link to={`/settings/custom-event-types/${props.original.id}`}>
          <Svg name="TableEditUser" />
        </Link>
      </span>
      {unusedInShipmentFilters(props.original.id) ? (
        <span className={styles.actionsBtnBlock}>
          <Svg
            name="TableDeleteUser"
            onClick={() => handleDeleteUser(props)}
            className={styles.btnDelete}
          />
        </span>
      ) : (
        <span className={styles.actionsBtnBlock}>
          <Svg
            name="circleQuestion"
            onClick={() => handleCantBeDeleted()}
            className={styles.btnDelete}
          />
        </span>
      )}
    </div>
  );

  return (
    <div>
      <div className={styles.titleBlock}>
        <div>
          <BackButton onBack={() => history.push('/settings')} />
          <h1 className="h2" style={{ margin: 0 }}>Custom event types ({customEventTypes.length})</h1>
          <div style={{ margin: '0 0 20px 0' }}>Manage custom event types for use with manual and scheduled event triggers.</div>
        </div>
        <div className={styles.btnAdditionalStyles}>
          <AddBtnRedesigned
            onClick={() => handleClickAddCustomEventType()}
          >
            + Add custom event type
          </AddBtnRedesigned>
        </div>
      </div>
      <div className={styles.pageContainer}>
        {customEventTypes.length > 0 ? (
          <div className={styles.wrapper}>
            <ReactTable
              data={customEventTypes}
              minRows={0}
              columns={[
                {
                  Header: 'Id',
                  accessor: 'id',
                  Cell: props => renderColumn(props.original.id),
                  headerStyle,
                  style,
                  width: 250,
                },
                {
                  Header: 'Name',
                  accessor: 'name',
                  Cell: props => renderColumn(props.original.name),
                  headerStyle,
                  style,
                },
                {
                  Header: 'Actions',
                  accessor: 'actions',
                  Cell: props => renderActions(props),
                  headerStyle,
                  style,
                  width: 250,
                  show: showActions(),
                },
              ]}
              sortable={false}
              showPageSizeOptions={false}
              resizable={false}
              howPageJump={false}
              getTrProps={() => ({
                style: { border: 'none' },
              })}
              PaginationComponent={TablePaginator}
              footerText="custom event types"
              pageSizeOptions={[20, 50, 100, 200]}
              totalRows={customEventTypes.length}
            />
          </div>
        ) : (
          <div>
            No custom event types have been configured, you can begin by adding one with the button above.
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomEventTypesList;
